/* Native mobile disclosures; Liquid remains the original facts and links. */
(() => {
  if (window.WagmadeMobileCopyLoaded) return;
  function createCopy(main) {
    const document = main.ownerDocument || window.document;
    let generated = [];
    let faqSource = null;
    function destroy() {
      generated.forEach(({ root, group }) => {
        group.remove();
        root.classList.remove('wm-copy-disclosure-ready');
      });
      generated = [];
      if (faqSource) faqSource.classList.remove('wm-copy-faq-source');
      faqSource = null;
      main.classList.remove('wm-copy-faq-ready');
    }
    function init() {
      destroy();
      const faq = main.querySelector('[data-wm-faq-shortcut]');
      main.querySelectorAll('[data-wm-home-trust]').forEach(root => {
        const items = root.querySelector('.wm-trust__items');
        if (!items) return;
        const group = document.createElement('div');
        group.className = 'wm-copy-disclosures';
        items.querySelectorAll('.wm-trust__item').forEach(item => {
          const title = item.querySelector('.wm-trust__item-title');
          const copy = item.querySelector('.wm-trust__item-copy');
          if (!title || !copy) return;
          const detail = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = title.textContent.trim();
          const body = document.createElement('div');
          const p = document.createElement('p');
          p.textContent = copy.textContent.trim();
          const link = document.createElement('a');
          link.href = item.getAttribute('href');
          link.textContent = item.querySelector('.wm-trust__item-link')?.textContent.trim() || title.textContent.trim();
          body.append(p, link); detail.append(summary, body); group.append(detail);
        });
        if (!group.children.length) return;
        if (faq) {
          const shortcut = document.createElement('a');
          shortcut.className = 'wm-copy-faq-link';
          shortcut.href = faq.getAttribute('href');
          shortcut.textContent = faq.textContent.trim();
          group.append(shortcut);
          faqSource = faq.closest('.wm-movement__image-caption');
          if (faqSource) faqSource.classList.add('wm-copy-faq-source');
          main.classList.add('wm-copy-faq-ready');
        }
        root.append(group); root.classList.add('wm-copy-disclosure-ready');
        generated.push({ root, group });
      });
    }
    return { init, refresh: init, destroy };
  }
  function start() {
    if (!window.WagmadeTheme || window.WagmadeMobileCopyLoaded) return;
    window.WagmadeTheme.register('homepage-mobile-copy', '#MainContent', createCopy);
    window.WagmadeMobileCopyLoaded = true;
    window.WagmadeTheme.init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', start, { once: true });
})();
